module.exports = new __parcel__URL__("closed-ko.571a6e14.webp").toString();